<template>
  <v-col cols="12">
    <template v-if="icon">
      <v-icon color="secondary" large>{{ icon }}</v-icon>
    </template>
    <template v-else-if="isPercent">
      <span
        class="text-h4"
        v-bind:style="{
          color: $coreScores.getColor(
            $coreScores.reverseFormat(coreCard.percentComplete)
          )
        }"
      >
        {{ coreCard.percentComplete | no_decimal }}%
      </span>
    </template>
    <template v-else-if="isPercentComplete">
      <span class="subtitle-1 lighttext--text">
        {{ coreCard.percentComplete | no_decimal }}% Complete
      </span>
      <span class="text-h4" style="opacity: 0;">%</span>
    </template>
    <template v-else-if="showPossible">
      <span
        class="text-h4"
        v-bind:style="{
          color: $coreScores.getColor(coreCard.value)
        }"
      >
        <template v-if="formatValue">
          {{ value | no_decimal }}
        </template>
        <template v-else>
          {{ value | one_decimal }}
        </template>
      </span>
      <span class="subtitle-1 lighttext--text"> of {{ possible }}</span>
      <span class="subtitle-2 float-right mt-3" v-if="coreCard.totalCollected">
        {{ coreCard.totalCollected }} {{ totalCollectedLabel }}
      </span>
      <span
        class="subtitle-2 float-right mt-3"
        v-if="coreCard.totalPercentComplete"
      >
        {{ coreCard.totalPercentComplete | no_decimal }}% participation
      </span>
    </template>
    <template v-else>
      <span class="text-h4">
        {{ value }}
      </span>
      <span class="subtitle-2 float-right mt-3" v-if="isFeedback">
        {{ coreCard.totalPercentComplete | no_decimal }}% acknowledged
      </span>
    </template>
  </v-col>
</template>

<script>
export default {
  name: "CoreCardScore",
  props: {
    coreCard: { type: Object },
    isPercent: { type: Boolean, default: false },
    isPercentComplete: { type: Boolean, default: false },
    showPossible: { type: Boolean, default: false },
    formatValue: { type: Boolean, default: false },
    icon: { type: String }
  },
  computed: {
    value() {
      return this.formatValue
        ? this.$coreScores.format(this.coreCard.value)
        : this.coreCard.value;
    },
    possible() {
      return this.formatValue
        ? this.$coreScores.format(this.coreCard.possible)
        : this.coreCard.possible;
    },
    totalCollectedLabel() {
      if (this.coreCard.type == this.$enums.coreCardTypes.PULSE) {
        return "responses collected";
      }
      return "reviews collected";
    },
    isFeedback() {
      return this.coreCard.type == this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK;
    }
  }
};
</script>
